// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1PSUv","col":"styles_col__4KjnM"};